"use strict";

import * as leafletMap from "@elements/leaflet-map";
import {find, findAll} from "@elements/dom-utils"
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-leaflet-map', function (mapElement) {

        let poiVarName = mapElement.dataset.leafletMapPois;
        let pois = [];

        if (poiVarName) {
            if (!window['_leafletMapPois']) {
                console.error('_leafletMapPois is not set');
            } else if (!window._leafletMapPois[poiVarName]) {
                console.error(poiVarName + ' is not set in _leafletMapPois', _leafletMapPois);
            } else {
                pois = _leafletMapPois[poiVarName];
            }
        }

        leafletMap.init({
            tilelayer: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
            leafletOptions:  {
                attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                maxZoom: 18,
                id: 'mapbox/outdoors-v11',
                accessToken: _config.mapAccessToken
            },
            mapOptions: {
                center: {lat: 47.01011105170685, lng: 8.482870389663853},
                zoom: 15,
                maxZoom: 18,
            },
            pois: pois,
            poiStyles: () => createPoiStyles(),
            onActivateMarker: (marker, api) => onActivateMarker(marker, api),
            onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
            clustering: true,
            clusteringOptions: () => {
                return {
                    showCoverageOnHover: false,
                    iconCreateFunction: function (cluster) {
                        return L.divIcon({
                            iconSize: [36, 36],
                            iconAnchor: [18, 18],
                            className: 'marker-cluster',
                            html: '<div class="marker-cluster__img"><img src="/static/img/map/cluster.svg"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span></div>'
                        });
                    }
                };
            }
        });
    });
}

function createPoiStyles() {
    return {
        main: {
            default: L.icon({
                iconUrl: '/static/img/map/poi.svg',
                iconSize: [24, 36],
                iconAnchor: [12, 36],
                popupAnchor: [-154, -12],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/poi.svg',
                iconSize: [24, 36],
                iconAnchor: [12, 36],
                popupAnchor: [-154, -12],
            })
        }
    };

}


function onActivateMarker(marker, api) {
    console.log("on activate marker");
}

function onDeactivateMarker(marker, mapObj) {
    console.log("on deactivate marker");
}
